export * from '@/application/helpers/convertPropNames'
export * from '@/application/helpers/lineClamp'
export * from '@/application/helpers/languageHelpers'
export * from '@/application/helpers/dateTimeHelper'
export * from '@/application/helpers/sortArrays'
export * from '@/application/helpers/locationHelper'
export * from '@/application/helpers/pathHelper'
export * from '@/application/helpers/screenOrientation'
export * from '@/application/helpers/urlHelper'
export * from '@/application/helpers/fileHelper'
export * from '@/application/helpers/assignmentHelper'
export * from '@/application/helpers/removeStylesFromHtml'
export * from '@/application/helpers/textFormattingHelper'
export * from '@/application/helpers/routeHelpers'

export const setInitials = (text: string | undefined): string => {
  if (text === undefined || text === null) {
    return ''
  }

  const names = text.split(' ')
  const firstNameInitial = names[0].charAt(0)
  const lastNameInitial = names[names.length - 1].charAt(0)

  return firstNameInitial + lastNameInitial
}
